import { render, staticRenderFns } from "./SearchForm.V2.vue?vue&type=template&id=279192c9&scoped=true&"
import script from "./SearchForm.V2.vue?vue&type=script&lang=js&"
export * from "./SearchForm.V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279192c9",
  null
  
)

export default component.exports